module.exports = ".creationModal .closeButton {\n  padding-top: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/account-form/account-form.component.css
// module id = ./src/app/accounts/account-form/account-form.component.css
// module chunks = main